import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import BuildingSelectModal from '../../components/modals/BuildingSelectModal';
import CHARTCOLORS from '../../helpers/chartColors';

export default function ReportBuildings(props) {
  const {
    organizationData,
    updatePayload,
    selectedBuildings,
    setSelectedBuildings,
  } = props;

  const [showBuildingModal, setShowBuildingModal] = useState(false);

  const [buildings, setBuildings] = useState([]);
  const [buildingIds, setBuildingIds] = useState([]);
  const [nonSelectedBuildings, setNonSelectedBuildings] = useState([]);

  useEffect(() => {
    if ('buildings' in organizationData) {
      setBuildings(organizationData['buildings']);
      const temp_building_ids = organizationData['buildings'].map(
        (building) => {
          return building.id;
        }
      );
      setBuildingIds(temp_building_ids);
      setSelectedBuildings(temp_building_ids);
    } else {
      setBuildings([]);
      setBuildingIds([]);
      setSelectedBuildings([]);
    }
    setNonSelectedBuildings([]);
  }, [organizationData, setSelectedBuildings]);

  useEffect(() => {
    updatePayload('ignore_building_ids', nonSelectedBuildings);
  }, [nonSelectedBuildings, updatePayload]);

  return (
    <>
      Select Buildings:
      <FontAwesomeIcon
        style={{
          fontSize: '20px',
          marginLeft: '0.5em',
          color: CHARTCOLORS[1],
          cursor: 'pointer',
        }}
        icon={faEdit}
        id={`report-building-select-popover`}
        onClick={() => setShowBuildingModal(true)}
      />
      <BuildingSelectModal
        show={showBuildingModal}
        onHide={() => setShowBuildingModal(false)}
        buildings={buildings}
        buildingIds={buildingIds}
        selectedBuildings={selectedBuildings}
        setSelectedBuildings={setSelectedBuildings}
        setNonSelectedBuildings={setNonSelectedBuildings}
      />
    </>
  );
}
